import * as React from 'react';
import App from 'src/state/App';

import Room from 'src/ui/Room';

const Router: React.SFC<{ store: App.Store }> = (
  ({store}) => {
    const app = store.getState();

    switch (app.location.type) {
      case 'r': {
        const room = App.CurrentRoom(app);
        const page = App.CurrentPage(app);

        if (room === null) {
          return <div>Room not found</div>;
        }

        if (page === null) {
          throw new Error('This should not happen');
        }

        return <Room store={store} room={room} page={page}/>;
      }
    }
  }
);

export default Router;



// WEBPACK FOOTER //
// ./src/ui/Router.tsx